import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { ContentService } from '../../services/content/content.service';

@Pipe({
  name: 'contentWebcam'
})
export class WebcamPipe implements PipeTransform {

  constructor(private contentService: ContentService) {
  }

  transform(entry: Models.ContentEntry): Models.WebcamEntry | Models.WebcamEntry[] {
    if (!entry) {
      return null;
    }

    if (entry.related && entry.related.entries && entry.related.entries.length > 0) {
      const entries: Models.WebcamEntry[] = [];

      for (const item of entry.related.entries) {
        const contentEntry = this.contentService.getEntry(item.id);
        const transformed = this.transform(contentEntry) as Models.WebcamEntry;
        if (transformed) {
          entries.push(transformed);
        }
      }

      return entries.length === 0 ? null : entries;
    }

    if (!entry.files) {
      return null;
    }

    if (!this.contentService.isValid(entry)) {
      return null;
    }

    let type = 'image';
    const files: Models.ContentFile[] = [];
    let preview;
    let contentFile;
    for (const item of entry.files) {
      const file = this.contentService.getFile(item.id);

      if (!file || !['images', 'videoPreviews', 'videos', 'iframePreviews', 'iframes'].includes(item.group)) {
        continue;
      }

      if (item.group === 'videos') {
        contentFile = file;
        type = 'video';
      }

      if (item.group === 'videoPreviews' || item.group === 'iframePreviews') {
        preview = file;
      }

      if (item.group === 'iframes') {
        contentFile = file;
        type = 'iframe';
      }

      if (item.group === 'images') {
        contentFile = file;
        preview = file;
      }

      files.push(file);
    }

    if (files.length === 0) {
      return null;
    }

    const webcam = new Models.WebcamEntry();
    if (!preview) {
      preview = contentFile;
    } else if (!contentFile) {
      contentFile = preview;
    }
    webcam.populateFromJSON({
      sourceId: entry._id, title: this.splitMuM(entry.title), type, fileURL: contentFile.url,
      thumbnailURL: preview.url, description: entry.detail ? entry.detail.description : null
    });

    return webcam;
  }

  splitMuM(title) {
    return title ? title.replace(/\s-\s/g, '<br/>') : null;
  }

}
